import { render } from "./AwardList.vue?vue&type=template&id=0876e148"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__